import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
import DonutChart from '../chart/DonutChart';

const propTypes = {
    className: PropTypes.string,
    avgTimePlayed: PropTypes.number,
    totalCompleted: PropTypes.number,
    avgScore: PropTypes.number,
    timePlayedGraphData: PropTypes.array,
    completionGraphData: PropTypes.array,
    scoreGraphData: PropTypes.array
};

const defaultProps = {
    className: '',
    avgTimePlayed: 0,
    totalCompleted: 0,
    avgScore: 0,
    timePlayedGraphData: [],
    completionGraphData: [],
    scoreGraphData: []
};

class ActivityStatsCharts extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const avgTimePlayed = StringUtil.getTimeStringForMs(this.props.avgTimePlayed);
        const totalCompleted = parseInt(this.props.totalCompleted.toFixed(0), 10);
        const avgScore = StringUtil.formatOverallScore(this.props.avgScore);

        return (
            <div
                id="charts"
                className={this.props.className}
            >
                <DonutChart
                    id="chart-complete-percent"
                    title={Strings['en'].activity.stats.COMPLETED_TITLE}
                    columns={this.props.completionGraphData}
                    summaryStat={totalCompleted}
                    tooltip={Strings['en'].activity.stats.COMPLETED_TT}
                />
                <DonutChart
                    id="chart-timeplayed"
                    title={Strings['en'].activity.stats.TP_TITLE}
                    columns={this.props.timePlayedGraphData}
                    summaryStat={avgTimePlayed}
                    tooltip={Strings['en'].activity.stats.TP_TT}
                />
                <DonutChart
                    id="chart-score"
                    title={Strings['en'].activity.stats.SCR_TITLE}
                    columns={this.props.scoreGraphData}
                    summaryStat={avgScore}
                    tooltip={Strings['en'].activity.stats.SCR_TT}
                />
            </div>
        );
    }
}

ActivityStatsCharts.propTypes = propTypes;
ActivityStatsCharts.defaultProps = defaultProps;

export default ActivityStatsCharts;